import { Injectable, Signal, signal } from '@angular/core';
import { toObservable } from '@angular/core/rxjs-interop';
import { Observable } from 'rxjs';
import { AuthUserClaims } from '../../auth/models/auth-user.model';

export interface LoggedUser {
  email: string;
  name: string;
  groups: string[];
}

/**
 * Logged-in user's state (derived from IdP claims).
 *
 * Exposes both `Signal` (recommended for new consumers) and
 * `Observable` (`getUser$`) for compatibility with existing consumers.
 */
@Injectable({
  providedIn: 'root',
})
export class LoggedUserDataService {
  private readonly userState = signal<LoggedUser | undefined>(undefined);

  readonly user: Signal<LoggedUser | undefined> = this.userState.asReadonly();

  private readonly user$ = toObservable(this.user);

  getUser$(): Observable<LoggedUser | undefined> {
    return this.user$;
  }

  getUserValue(): LoggedUser | undefined {
    return this.userState();
  }

  setUser(value: AuthUserClaims): void {
    this.userState.set({
      email: value.email ?? '',
      name: value.name ?? '',
      groups: value.groups ?? [],
    });
  }
}
